import loadingIcon from "../../icons/loading.svg";
import './style.css'

const Index = ({visible}) => {
    return visible ? <div className={"loader"}>
                <img src={loadingIcon}/>
            </div> : null
}
export default Index;